import { Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { dateTimeFormat } from "../../../util/DateUtil";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { currencyRound } from "../../../util/DoubleUtil";

const CupomCantinaPageView = ({ pageCupomCantina, handleChangePage }) => {

    const handleSumTotalCupom = (listVendaCatina) => {
        let total = 0;
        listVendaCatina.forEach((vc) => {
            total += vc.precoVendido * vc.quantidade
        })
        return total;
    }

    return (
        <Grid container spacing={3}>
            <Grid size={12}>
                <Typography variant='h6'>Compra</Typography>
            </Grid>
            {pageCupomCantina.content.map((cupomCantina) =>
                <Grid key={cupomCantina.codigo} size={12}>
                    <p>Data Hora Compra: {dateTimeFormat(cupomCantina.dataHoraCompra)}</p>
                    <Table>
                        <TableHead>
                            <TableCell>
                                Descrição
                            </TableCell>
                            <TableCell>
                                Valor Unit.
                            </TableCell>
                            <TableCell>
                                Quant.
                            </TableCell>
                            <TableCell>
                                Valor Unit. X Quant
                            </TableCell>
                        </TableHead>
                        <TableBody>
                            {cupomCantina.listVendaCantina.map((vendaCantina) => (
                                <TableRow key={vendaCantina.codigo}>
                                    <TableCell>
                                        {vendaCantina.produtoCantina.descricao}
                                    </TableCell>
                                    <TableCell>
                                        R$ {currencyRound(vendaCantina.precoVendido)}
                                    </TableCell>
                                    <TableCell>
                                        {currencyRound(vendaCantina.quantidade)}
                                    </TableCell>
                                    <TableCell>
                                        R$ {currencyRound(vendaCantina.quantidade * vendaCantina.precoVendido)}

                                    </TableCell>
                                </TableRow>
                            ))}

                        </TableBody>
                    </Table>

                    {/* <p>Total Cupom: R$ {cupomCantina.listVendaCantina.reduce((n, { quantidade }, { precoVendido }) => n + (quantidade * precoVendido), 0)}</p> */}
                    <p>Total Cupom: R$ {currencyRound(handleSumTotalCupom(cupomCantina.listVendaCantina))}</p>
                    {console.log(cupomCantina)}
                    {console.log(cupomCantina.listVendaCantina)}
                    {/* <p>Total Cupom: R$ {cupomCantina && cupomCantina.listVendaCatina && cupomCantina.listVendaCatina.reduce((accumulator, { vc }) => accumulator + (vc.precoVendido * vc.quantidade), 0)}</p> */}

                    {/* <ul>
                        {cupomCantina.listVendaCantina.map((vendaCantina) => (
                            <li>{vendaCantina.produtoCantina.descricao} - </li>
                        ))}
                    </ul> */}
                </Grid>)
            }
            <Grid size={12}>
                <TablePagination
                    rowsPerPageOptions={[]}
                    rowsPerPage={pageCupomCantina.size ? pageCupomCantina.size : 0}
                    component="div"
                    count={pageCupomCantina.totalElements}
                    page={pageCupomCantina.number}
                    onPageChange={handleChangePage}
                    labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                    slots={{
                        actions: TablePaginationActions
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default CupomCantinaPageView;